/**
 * THIS IS THE ONLY FILE THAT MAY CALL initializeApp().
 * Import db and auth from this file. Never call initializeApp() elsewhere.
 */
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator, signInWithCustomToken } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
};

const isConfigured = firebaseConfig.apiKey && firebaseConfig.apiKey !== '';
const useEmulator  = import.meta.env.VITE_USE_EMULATOR === 'true';

let app = null;
let db = null;
let auth = null;
let functions = null;

if (isConfigured) {
  try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
    functions = getFunctions(app, 'us-central1');

    if (useEmulator) {
      connectFirestoreEmulator(db, '127.0.0.1', 8080);
      connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
      connectFunctionsEmulator(functions, '127.0.0.1', 5001);
      console.log('Firebase connected (emulator mode)');
    } else {
      console.log('Firebase connected');
    }

    // CI custom-token auth — live-surface-gate injects this via Playwright addInitScript
    // before page load. signInWithCustomToken fires early; TenantContext's auth-state
    // listener picks it up and loads tenant config once auth settles.
    if (typeof window !== 'undefined' && window.__ELYON_CI_TOKEN__) {
      signInWithCustomToken(auth, window.__ELYON_CI_TOKEN__).catch((e) =>
        console.warn('[CI] custom token sign-in failed:', e.message)
      );
    }
  } catch (e) {
    console.warn('Firebase init failed:', e.message);
  }
} else {
  console.log('Firebase not configured — using local fallback');
}

export { app, db, auth, functions, isConfigured, useEmulator };
